import React from 'react';
import { useNavigate } from 'react-router-dom';

const StartupShowcases = () => {
  const navigate = useNavigate();

  return (
    <div className="startup-showcases-page">
      {/* Header Section */}
      <div className="page-header">
        <div className="container">
          <button className="back-button" onClick={() => navigate(-1)}>
            <i className="fas fa-arrow-left"></i> Back to AgConverge
          </button>
          <div className="header-content">
            <div className="icon-large">⚡</div>
            <h1>Startup Showcases</h1>
            <p className="subtitle">Lightning talks from innovative agtech startups</p>
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <section className="content-section">
        <div className="container">
          <div className="content-card">
            <h2>About This Session</h2>
            <p>
              In this session, ten innovative agtech startups will take the stage to present
              their solutions in quick, focused pitches (5 minutes each, including transition).
              Representing diverse categories—from water and irrigation to livestock health,
              soil management, and digital agriculture—these companies bring forward cutting-edge
              ideas aimed at solving real challenges faced by farmers.
            </p>

            <h3>More Than Just Pitches</h3>
            <p>
              Unlike a typical pitch contest, these startups are not competing for prizes.
              Instead, their presentations set the stage for the Farmers Tech Adoption Challenge.
              Farmers in the audience will later sit down at roundtables, matched with the
              startups and themes most relevant to their operations, and evaluate whether they
              would adopt these technologies, under what conditions, and why.
            </p>

            <p>
              The pitches provide a fast-paced showcase of innovation while grounding the
              farmer-led adoption game in real, market-ready solutions.
            </p>

            <div className="announcement-box">
              <h4>Coming Soon</h4>
              <p><strong>We will share the lineup of start-ups soon!</strong></p>
            </div>
          </div>

          {/* Features Grid */}
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3>10 Startups</h3>
              <p>Diverse agtech solutions across multiple categories</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⏱️</div>
              <h3>5-Minute Pitches</h3>
              <p>Quick, focused presentations with live demos</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🌾</div>
              <h3>Real Solutions</h3>
              <p>Market-ready technologies addressing farmer challenges</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💬</div>
              <h3>Interactive Q&A</h3>
              <p>Direct engagement with farmers and industry experts</p>
            </div>
          </div>

          {/* Categories Section */}
          <div className="categories-section">
            <h2>Technology Categories</h2>
            <div className="categories-list">
              <div className="category-tag">💧 Water & Irrigation</div>
              <div className="category-tag">🐄 Livestock Health</div>
              <div className="category-tag">🌱 Soil Management</div>
              <div className="category-tag">📱 Digital Agriculture</div>
              <div className="category-tag">🤖 Automation & Robotics</div>
              <div className="category-tag">📊 Data Analytics</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StartupShowcases;